export default __webpack_public_path__ + "static/media/profile-icon.2ab4c269.svg";